/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { memberInputSchema } from './memberInputSchema';
import { resolutionCandidateDtoSchema } from './resolutionCandidateDtoSchema';

export const memberResolveResultSchema = z.object({
  autoMatch: z.string().nullish(),
  get candidates() {
    return z.array(resolutionCandidateDtoSchema);
  },
  get input() {
    return memberInputSchema;
  },
});
